"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitingAfmFactory = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
var uniqWith_1 = tslib_1.__importDefault(require("lodash/uniqWith"));
var ObjRefConverter_1 = require("../../../../convertors/toBackend/ObjRefConverter");
var MeasureConverter_1 = require("../../../../convertors/toBackend/afm/MeasureConverter");
var api_1 = require("../../../../utils/api");
var LimitingAfmFactory = /** @class */ (function () {
    function LimitingAfmFactory(authCall, displayFormRef, workspace) {
        var _this = this;
        this.authCall = authCall;
        this.displayFormRef = displayFormRef;
        this.workspace = workspace;
        this.getAfm = function (filters, measures, relativeDateFilters) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filtersPart, _a, measuresPart, mergedFiltersPart;
            var _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(filters === null || filters === void 0 ? void 0 : filters.length) && !(measures === null || measures === void 0 ? void 0 : measures.length) && !(relativeDateFilters === null || relativeDateFilters === void 0 ? void 0 : relativeDateFilters.length)) {
                            return [2 /*return*/, undefined];
                        }
                        if (!(filters === null || filters === void 0 ? void 0 : filters.length)) return [3 /*break*/, 2];
                        _b = {};
                        _c = {};
                        return [4 /*yield*/, this.createFiltersExpressionFromAttributeFilters(filters)];
                    case 1:
                        _a = [
                            (_b.expression = (_c.value = _d.sent(),
                                _c),
                                _b)
                        ];
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _d.label = 3;
                    case 3:
                        filtersPart = _a;
                        measuresPart = (measures === null || measures === void 0 ? void 0 : measures.length) ? measures.map(MeasureConverter_1.convertMeasure) : undefined;
                        mergedFiltersPart = filtersPart &&
                            relativeDateFilters && tslib_1.__spreadArrays(filtersPart, relativeDateFilters);
                        return [2 /*return*/, {
                                attributes: [
                                    {
                                        localIdentifier: "a1",
                                        displayForm: ObjRefConverter_1.toBearRef(this.displayFormRef),
                                    },
                                ],
                                filters: mergedFiltersPart || filtersPart || relativeDateFilters,
                                measures: measuresPart,
                            }];
                }
            });
        }); };
        this.createFiltersExpressionFromAttributeFilters = function (filters) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filterDisplayForms, allDisplayFormRefs, _a, identifierUriPairs, displayFormAttributeUriMapping, getDisplayFormAttributeUri, getFilterAttributeUri, getUriForIdentifier, attributeRefUri, groupsByOverAttribute, expressionsByOverAttribute;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        filterDisplayForms = filters.map(function (f) { return sdk_model_1.filterObjRef(f.attributeFilter); });
                        allDisplayFormRefs = uniqWith_1.default(tslib_1.__spreadArrays([this.displayFormRef], filterDisplayForms), sdk_model_1.areObjRefsEqual);
                        return [4 /*yield*/, Promise.all([
                                this.getIdentifierUriPairs(filters),
                                this.getDisplayFormAttributeUriMapping(allDisplayFormRefs),
                            ])];
                    case 1:
                        _a = _b.sent(), identifierUriPairs = _a[0], displayFormAttributeUriMapping = _a[1];
                        getDisplayFormAttributeUri = function (ref) {
                            var entry = displayFormAttributeUriMapping.find(function (_a) {
                                var displayFormRef = _a[0];
                                return sdk_model_1.areObjRefsEqual(displayFormRef, ref);
                            });
                            ts_invariant_1.default(entry, "Attribute URI for the display form \"" + sdk_model_1.objRefToString(ref) + "\" was not found");
                            return entry[1];
                        };
                        getFilterAttributeUri = function (attributeFilter) {
                            return getDisplayFormAttributeUri(sdk_model_1.filterObjRef(attributeFilter));
                        };
                        getUriForIdentifier = function (objRef) {
                            if (sdk_model_1.isUriRef(objRef)) {
                                return objRef.uri;
                            }
                            else {
                                var foundUri = identifierUriPairs.find(function (pair) { return pair.identifier === objRef.identifier; });
                                if (foundUri === undefined) {
                                    throw new Error("URI for identifier " + objRef.identifier + " have not been found");
                                }
                                return foundUri.uri;
                            }
                        };
                        attributeRefUri = getDisplayFormAttributeUri(this.displayFormRef);
                        groupsByOverAttribute = groupBy_1.default(filters, function (filter) { return getUriForIdentifier(filter.overAttribute); });
                        expressionsByOverAttribute = Object.keys(groupsByOverAttribute).map(function (overAttribute) {
                            var filterGroupExpression = groupsByOverAttribute[overAttribute]
                                .map(function (parentFilter) {
                                var isNegativeFilter = sdk_model_1.isNegativeAttributeFilter(parentFilter.attributeFilter);
                                var filterElements = sdk_model_1.filterAttributeElements(parentFilter.attributeFilter);
                                var parentFilterAttributeUri = getFilterAttributeUri(parentFilter.attributeFilter);
                                if (!sdk_model_1.isAttributeElementsByRef(filterElements)) {
                                    throw new sdk_backend_spi_1.NotSupported("Only attribute elements by ref are supported in elements attribute filter");
                                }
                                var elementsString = filterElements.uris
                                    .map(function (attributeElementUri) { return "[" + attributeElementUri + "]"; })
                                    .join(", ");
                                var operatorString = isNegativeFilter ? "NOT IN" : "IN";
                                return "[" + parentFilterAttributeUri + "] " + operatorString + " (" + elementsString + ")";
                            })
                                .join(" AND ");
                            return "((" + filterGroupExpression + ") OVER [" + overAttribute + "] TO [" + attributeRefUri + "])";
                        });
                        return [2 /*return*/, expressionsByOverAttribute.join(" AND ")];
                }
            });
        }); };
        this.getIdentifierUriPairs = function (filters) {
            var allIdentifiersUsed = _this.getAllIdentifiersUsedInAttributeFilters(filters);
            return _this.authCall(function (sdk) { return sdk.md.getUrisFromIdentifiers(_this.workspace, allIdentifiersUsed); });
        };
        this.getAllIdentifiersUsedInAttributeFilters = function (filters) {
            return flatMap_1.default(filters, function (filter) {
                // the only candidates are the filter itself and the overAttribute
                return [filter.overAttribute, sdk_model_1.filterObjRef(filter.attributeFilter)]
                    .filter(sdk_model_1.isIdentifierRef)
                    .map(function (ref) { return ref.identifier; });
            });
        };
        this.getDisplayFormAttributeUriMapping = function (displayForms) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var displayFormUris;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefsToUris(displayForms, this.workspace, this.authCall)];
                    case 1:
                        displayFormUris = _a.sent();
                        return [2 /*return*/, this.authCall(function (sdk) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var response;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, sdk.md.getObjects(this.workspace, displayFormUris)];
                                        case 1:
                                            response = _a.sent();
                                            return [2 /*return*/, displayForms.map(function (displayForm) {
                                                    var attribute = response.find(function (item) {
                                                        if (sdk_model_1.isIdentifierRef(displayForm)) {
                                                            return displayForm.identifier === item.attributeDisplayForm.meta.identifier;
                                                        }
                                                        else {
                                                            return displayForm.uri === item.attributeDisplayForm.meta.uri;
                                                        }
                                                    });
                                                    if (attribute === undefined) {
                                                        throw new Error("Cannot find attribute for display form");
                                                    }
                                                    return [displayForm, attribute.attributeDisplayForm.content.formOf];
                                                })];
                                    }
                                });
                            }); })];
                }
            });
        }); };
    }
    return LimitingAfmFactory;
}());
exports.LimitingAfmFactory = LimitingAfmFactory;
//# sourceMappingURL=limitingAfmFactory.js.map